import { SsoType } from '@diritto/common/account/constants/sso.constant';
import {
  ClickAction,
  ClickTargetType,
  TrackerPosition,
  TrackingEventType,
} from '@diritto/common/tracker/tracking-event.constant';
import { useAuthState } from 'contexts/AuthProvider';
import { useTrackingState } from 'contexts/TrackingProvider';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMarketingAgree } from 'state-hooks/accounts/useMarketingAgree';

export const usePromotionEligibilityCheck = () => {
  const router = useRouter();
  const { tracker } = useTrackingState();

  const [isUserCertificated, setIsUserCertificated] = useState(false);
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false);
  const [ridiSsoLinked, setRidiSsoLinked] = useState(false);

  const { isLoggedIn, user, ssoList } = useAuthState();
  const { marketingAgree } = useMarketingAgree();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    if (user) {
      setIsUserCertificated(user.ageVerified);
    }

    if (ssoList) {
      const linked = ssoList.find(sso => sso.ssoType === SsoType.Ridi);
      setRidiSsoLinked(!!linked);
    }
  }, [isLoggedIn, user, ssoList]);

  useEffect(() => {
    if (marketingAgree) {
      setIsNotificationEnabled(marketingAgree.agree);
    }
  }, [marketingAgree]);

  const handleRidiSSoLink = useCallback(() => {
    tracker.track(TrackingEventType.Click, {
      label: '리디 ID 연동',
      action: ClickAction.EventButton,
      clickType: ClickTargetType.Button,
      trackerExtraInfo: { trackerPosition: TrackerPosition.Promotion },
    });
    router.push('/accounts/diritto-account');
  }, [router, tracker]);

  const handleMarketingAgreement = useCallback(() => {
    tracker.track(TrackingEventType.Click, {
      label: '알림 수신 동의',
      action: ClickAction.EventButton,
      clickType: ClickTargetType.Button,
      trackerExtraInfo: { trackerPosition: TrackerPosition.Promotion },
    });
    router.push('/accounts/diritto-account');
  }, [router, tracker]);

  const handleUserCertification = useCallback(() => {
    tracker.track(TrackingEventType.Click, {
      label: '본인인증',
      action: ClickAction.EventButton,
      clickType: ClickTargetType.Button,
      trackerExtraInfo: { trackerPosition: TrackerPosition.Promotion },
    });
    router.push('/accounts/diritto-account');
  }, [router, tracker]);

  return useMemo(
    () => ({
      isUserCertificated,
      isNotificationEnabled,
      ridiSsoLinked,
      handleRidiSSoLink,
      handleUserCertification,
      handleMarketingAgreement,
    }),
    [
      handleMarketingAgreement,
      handleRidiSSoLink,
      handleUserCertification,
      isNotificationEnabled,
      isUserCertificated,
      ridiSsoLinked,
    ],
  );
};
